module.exports = __webpack_public_path__ + "static/truth-social-bg-554c52fd38421bb48ac245867074c037.jpg";